import { useSelector } from "react-redux";

const useCheckUserRole = () => {
  const user = useSelector((state) => state.accountDefault);
  return user.is_superuser && user.is_staff;
};

export default useCheckUserRole;
